import { SETTING_IDE } from "../constants";

const { isMobile, isBrowser, isChrome } = require("react-device-detect")
const Crypt = require('hybrid-crypto-js').Crypt;
const strConfig = require('text-obfuscator');

export const sendMobile = (send) => {
    try {
        if (isMobile && !isBrowser && !isChrome) {
          window.ReactNativeWebView.postMessage(send)
        }
    } catch (error) {
        //console.log(error)
    }
}

export const encrypt = (message) => {
    try {
        const crypt = new Crypt();
        return crypt.encrypt(strConfig.decode(process.env.REACT_APP_5G3B2DRMQBAZ, SETTING_IDE), message);
    } catch (error) {
        //console.log(error)
        return 'SIN ENCRIPTAR'
    }
}

export const decrypt =  (encrypted) => {
    try {
        const crypt = new Crypt();
        return   crypt.decrypt(strConfig.decode(process.env.REACT_APP_E74MQNIQZSW3, SETTING_IDE), encrypted).message;
    } catch (error) {
        //console.log(error)
        return undefined
    }
}